import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import animateScrollTo from 'animated-scroll-to';
import {
    faDatabase, faLeaf, faTabletAlt, faUnlockAlt, faColumns, faImage, faTv,
    faWifi, faInfo, faMicrophone, faCube, faClock, faMoon, faMusic, faStopwatch, faGamepad, faMoneyBill,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Button from '../../../common/button/Button';
import ProBadge from '../../../common/ProBadge/ProBadge';

const devices = [
    {
        imgClassName: 'appsPro',
        img: '/imgAplicativosPage/mobile-phones-pro.jpg',
        imgAlt: 'Antena 1 PRO Android/iOS app',
        title: 'Antena 1 PRO',
        icons: [
            { icon: 'pro', sentence: 'Acesso a todas as funcionalidades' },
            { icon: faClock, sentence: 'Acorde ouvindo a sua rádio preferida' },
            { icon: faMoon, sentence: 'Modo Dark para descansar os olhos à noite' },
            { icon: faMusic, sentence: 'Streams e podcasts exclusivos' },
            { icon: faTabletAlt, sentence: 'Disponível para smartphones e tablets' },
            { icon: faStopwatch, sentence: 'Disponível para smartwatches' },
        ],
        availability: 'Disponível para iOS e Android',
        buttons: [
            {
                link: 'https://apps.apple.com/us/app/antena-1-pro/id1565020388',
                title: 'Baixar na Apple Store',
                img: '/imgAplicativosPage/appstore-button-2x.png',
                imgAlt: 'Icone baixar na Apple Store',
            },
            {
                link: 'https://play.google.com/store/apps/details?id=br.com.antena1.app',
                title: 'Baixar no Google Play',
                img: '/imgAplicativosPage/playstore-button-2x.png',
                imgAlt: 'Icone baixar no Google Play',
            },
        ],
    },
    {
        imgClassName: 'appsLite',
        img: '/imgAplicativosPage/mobile-phones.png',
        imgAlt: 'Antena 1 Android/iOS app',
        title: 'Antena 1',
        icons: [
            { icon: faDatabase, sentence: 'Não possui custo' },
            { icon: faColumns, sentence: 'Design simples e objetivo' },
            { icon: faImage, sentence: 'Capa de álbuns em destaque' },
            { icon: faLeaf, sentence: 'Rápida taxa de resposta em conexões estáveis' },
            { icon: faTabletAlt, sentence: 'Disponivel para smartphones e tablets' },
            { icon: faUnlockAlt, sentence: 'Escutar com o aparelho bloquedo' },
        ],
        availability: 'Disponível para iOS e Android',
        buttons: [
            {
                link: 'https://itunes.apple.com/br/app/id378370013?mt=8',
                title: 'Baixar na Apple Store',
                img: '/imgAplicativosPage/appstore-button-2x.png',
                imgAlt: 'Icone baixar na Apple Store',
            },
            {
                link: 'https://play.google.com/store/apps/details?id=br.com.mobits.antena1',
                title: 'Baixar no Google Play',
                img: '/imgAplicativosPage/playstore-button-2x.png',
                imgAlt: 'Icone baixar no Google Play',
            },
        ],
    },
    {
        imgClassName: 'appsTV',
        img: '/imgAplicativosPage/TV-apps.jpg',
        imgAlt: 'Antena 1 TV app',
        title: 'Antena 1 na sua Televisão',
        icons: [
            { icon: faMoneyBill, sentence: 'Não possui custo' },
            { icon: faColumns, sentence: 'Design simples e objetivo' },
            { icon: faImage, sentence: 'Capa de álbuns em destaque' },
            { icon: faWifi, sentence: 'Rápida taxa de resposta em conexões estáveis' },
            { icon: faTv, sentence: 'Disponivel para TVs Samsung, LG, Apple TV e Fire TV' },
            { icon: faGamepad, sentence: 'Use seu controle remoto' },
        ],
        availability: 'Saiba como instalar em seu aparelho de TV',
        buttons: [
            {
                link: '/noticias/app-antena-1-como-instalar-na-sua-apple-tv',
                title: 'Saiba como instalar na Apple TV',
                img: '/imgAplicativosPage/appletv-button-2x.png',
                imgAlt: 'Icone Apple TV',
            },
            {
                link: '/noticias/app-antena-1-como-instalar-na-sua-tv-lg',
                title: 'Saiba como instalar na sua TV LG',
                img: '/imgAplicativosPage/lg-button-2x.png',
                imgAlt: 'Icone LG',
            },
            {
                link: '/noticias/app-antena-1-como-instalar-na-sua-tv-samsung',
                title: 'Saiba como instalar na sua TV Samsung',
                img: '/imgAplicativosPage/samsung-button-2x.png',
                imgAlt: 'Icone Samsung TV',
            },
            {
                link: 'https://www.amazon.com.br/Antena-1/dp/B07V2NVTBW',
                title: 'Instala no seu FireTV',
                img: '/imgAplicativosPage/amazon-fireTV-button-2x.png',
                imgAlt: 'Icone Fire TV',
            },
        ],
    },
    {
        imgClassName: 'appsSmartSpeakers',
        img: '/imgAplicativosPage/smart-speakers.jpg',
        imgAlt: 'Antena 1 smart speakers app',
        title: 'Antena 1 nos seus smart speakers',
        icons: [
            { icon: faDatabase, sentence: 'Não possui custo' },
            { icon: faColumns, sentence: 'Saiba o nome da música e artista que está tocando na hora' },
            { icon: faMicrophone, sentence: 'Comando de voz fácil e prático de usar' },
            { icon: faLeaf, sentence: 'Rápida taxa de resposta em conexões estáveis' },
            { icon: faInfo, sentence: 'Pioneirismo, Antena 1 agora com assistente virtual' },
            { icon: faCube, sentence: 'Faça parte de um dos aplicativos mais modernos do momento' },
        ],
        availability: 'Disponível nas plataformas',
        buttons: [
            {
                link: 'https://www.amazon.com.br/Antena-1-Um/dp/B07XJ28V8Q/',
                title: 'Baixar na Amazon Alexa',
                img: '/imgAplicativosPage/alexa-button-2x.png',
                imgAlt: 'Icone baixar na Amazon Alexa',
            },
            {
                link: 'https://assistant.google.com/services/a/uid/000000637b7e027c',
                title: 'Baixar no Google Assistant',
                img: '/imgAplicativosPage/google-assistant-button-2x.png',
                imgAlt: 'Icone baixar no google assistant',
            },
        ],
    },
];

const Device = ({ data }) => (
    <div className="contentMain">
        <div className="containerImg">
            <figure className={data.imgClassName}>
                <img src={data.img} alt={data.imgAlt} />
            </figure>
        </div>
        <div className="contentApp">
            <h3>
                {data.title}
            </h3>
            <div className="secondContent">
                {data.icons.map((icon) => (
                    <div className="contentIcon" key={icon.icon}>
                        {
                            icon.icon === 'pro' ? <ProBadge className="aplicativosPageProBadge" title="Pro" /> : <FontAwesomeIcon icon={icon.icon} size="2x" className="faAplicativos" width="16" />
                        }
                        <p>
                            {
                                icon.sentence
                            }
                            {' '}
                            {icon.icon === 'pro' && <Link className="proLink" to="/vantagens-da-assinatura-pro">Pro</Link>}
                        </p>
                    </div>))}
            </div>
            <p className="minText">
                {data.availability}
            </p>
            <div className="downloads-app">
                {data.buttons.map((button) => (
                    <Button className="btnStore" key={button.link} href={button.link} title={button.title}>
                        <img src={button.img} alt={button.imgAlt} />
                    </Button>))}
            </div>
        </div>
    </div>
);

Device.propTypes = exact({
    data: PropTypes.shape({
        imgClassName: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        img: PropTypes.string.isRequired,
        imgAlt: PropTypes.string.isRequired,
        availability: PropTypes.string.isRequired,
        icons: PropTypes.arrayOf(PropTypes.shape({
            icon: PropTypes.oneOfType([
                PropTypes.object,
                PropTypes.string,
            ]).isRequired,
            sentence: PropTypes.string.isRequired,
        })).isRequired,
        buttons: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string.isRequired,
            link: PropTypes.string.isRequired,
            img: PropTypes.string.isRequired,
            imgAlt: PropTypes.string.isRequired,
        })).isRequired,
    }).isRequired,
});

const AplicativosComponent = () => {
    useEffect(() => { animateScrollTo(0, { speed: 700 }); }, []);

    return (
        <section className="sectionApp">
            <header>
                <h1>Aplicativos</h1>
                <p className="pageSubtitle">Escolha a melhor versão da Antena 1 para você</p>
            </header>
            <p className="radioDescription">
                A Rádio Antena 1 traz os grandes sucessos das paradas
                americanas e europeias com uma variedade incrível de artistas
                das décadas 1960, 1970, 1980, 1990, 2000 e 2010 você pode ter
                os grandes clássicos e lançamentos para embalar suas noites,
                relaxar antes/após seu período de sono ou ter aquele gás a mais
                em um dia de trabalho.
            </p>
            {devices.map((data) => <Device key={data.img} data={data} />)}
        </section>
    );
};

export default AplicativosComponent;
